<template>
  <div class="container">
    <div class="heade-bar">
      <span class="collapse-switcher" @click.prevent="collapse">
        <i class="iconfont icon-shouqi1" v-show="isCollapse || isShrink"></i>
        <i class="iconfont icon-zhankai1" v-show="!isCollapse && !isShrink"></i>
      </span>
      <div class="logo">
        <img :src="adminImg" v-if="adminImg" @click="toIndex">
        <span @click="toIndex">{{ sysName }}</span>
      </div>
      <div class="zc-select" v-if="isSupervisor">
          <el-select :placeholder="$t('common_00327')" v-model="sourceInfo" @change="changeSelect()" value-key="id">
            <el-option v-for="(item,k) in selectList" :label="item.resourceTitle" :value="item.resource" :key="k"></el-option>
          </el-select>
        </div>
      <span class="full-screen">
        <!-- <span v-if="isOlduser" @click="toV2">{{$t('common_10010')}}</span> -->
        <!-- <i class="iconfont icon-kanban"></i> -->
        <!-- <el-tooltip class="item" effect="dark" :content="$t('common_00233')" placement="bottom">
          <el-badge :value="notifyCount" :max="99" class="item">
            <i class="iconfont icon-xiaoxi1" @click="toNotify"></i>
          </el-badge>
        </el-tooltip> -->
        <el-tooltip class="item" effect="dark" :content="$t('common_00321')" placement="bottom"> 
          <i class="iconfont icon-fangda" v-show="!isFullScreen" @click.prevent="screenfull"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" :content="$t('common_00322')" placement="bottom">
          <i class="iconfont icon-suoxiao" v-show="isFullScreen" @click.prevent="screenfull"></i>
        </el-tooltip>
      </span>
      <span class="tool-bar">
      
        <el-dropdown class="user-info-dropdown" trigger="hover">
          <span class="el-dropdown-link">
            <img :src="headImageUrl" v-if="headImageUrl">
            {{ userTitle }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="FLAG_CHANGE_PW = true">{{
              $t("common_00246")
            }}</el-dropdown-item>
            <el-dropdown-item @click.native="logout">{{
              $t("common_00001")
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </span>
    </div>
    <div class="myMain">
      <div class="menu" id="menu">
        <div class="menu-bar" :class=" isCollapse || isShrink ? 'menu-bar-collapse-width' : 'menu-bar-width'">
          <transition name="my_fade">
            <el-menu
              :class="[isCollapse || isShrink ? 'menu-bar-collapse-width' : 'menu-bar-width','menu_pt20']"                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
              :unique-opened="true"
              ref="elmenu"
              :collapse="isCollapse || isShrink"
              :collapse-transition="false"
            >
              <template v-for="(ele, key) in list">
              <el-submenu
                v-if="ele.child&&ele.child.length"
                :popper-class="ele.isClose?'collapse-menu-close':isCollapse || isShrink  ? 'collapse-menu' : ''"
                :index="String(ele.active)"
                :ref="('menu'+ele.active)"
                :class="ele.active == isactive ? 'is-openeds' : ele.isClose ? 'is-opened-no' : ''"
                :show-timeout="500"
              >
                <div slot="title" :class=" isCollapse || isShrink ? 'p20 m-title' :'m-title' " @click="tolink(ele)">
                  <i :class="ele.icon"></i>
                  <div class="titleName" >{{ele.name}}</div>
                </div>
                <el-menu-item-group v-for="(item,key) in ele.child" :key="key">
                  <span slot="title">{{item.name}}</span>
                  <el-menu-item
                    v-for="(i,key) in item.children"
                    :key="key"
                    :class="['my-el-menu-item',{'menuActive':i.focus==isfocus?true:false}]"
                    v-setPermission
                    :permissionInfo="i.permission">
                    <a :href="i.router" 
                      :target="((i.router == 'chargeMonitor.html')||(i.router == 'http://www.xcharge.com/OpenAPI/')) 
                      && '_blank'" 
                      :class="['menu_li',{disbled:i.router == 'createDepot.html' && creatFlag}]">
                      {{i.name}}
                      <span class="menu_li_span" v-if="i.notify&&i.notify > 0">{{i.notify>99?'99+':i.notify}}</span>
                    </a>
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
              <template v-else>
                <div v-if="ele.name" :index="String(ele.active)" :class="['el-submenu', 'my_single',{ 'is-openeds': ele.active == isactive ? true : false }]">
                  <div class="el-submenu__title my_single_title" @click="tolink(ele)">
                    <div :class=" isCollapse || isShrink ? 'p20 m-title' :'m-title' ">
                      <i :class="ele.icon"></i>
                      <div class="titleName" >{{ele.name}}</div>
                    </div>
                  </div>
                </div>
              </template>
              </template>
            </el-menu>
          </transition>
        </div>
      </div>
      <div class="main-con">
        <slot></slot>
      </div>
    </div>
    <el-dialog
      :title="$t('common_00246')"
      :lock-scroll="false"
      :visible="FLAG_CHANGE_PW"
      @close="close"
      width="30%">
      <div class="dialog-changePw">
        <div class="model">
          <div class="title">{{ $t("common_00247") }}</div>
          <el-input
            size="medium"
            v-model="password"
            :placeholder="$t('common_00250')"
            type="password"
          />
        </div>
        <div class="model">
          <div class="title">{{ $t("common_00248") }}</div>
          <el-input
            size="medium"
            v-model="newPassword"
            :placeholder="$t('common_00249')"
            type="password"
          />
        </div>
        <div class="model">
          <div class="title">{{ $t("common_00268") }}</div>
          <el-input
            size="medium"
            v-model="newPassword1"
            :placeholder="$t('common_00249')"
            type="password"
          />
        </div>
        <div class="buttons">
          <el-button @click="close" size="medium">{{
            $t("common_00215")
          }}</el-button>
          <el-button type="primary" @click="uptPassword" size="medium">{{
            $t("common_00234")
          }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  requestUrl,
  ajax,
  checkLogin,
  getLoginInfo,
  checkIdType,
} from "@/assets/utils/network";
import screenfull from "screenfull";
export default {
  data() {
    return {
      catchActive:'',
      isClose: false, // 是否关闭二级菜单
      isPc: true,
      isOlduser:true, // 角色创建时间
      product:'cn',
      noPermissions:[],
      lang:'zh',
      sourceInfo:[],
      isSupervisor:false,
      creatFlag:false,
      loginId: "",
      password: "",
      newPassword: "",
      newPassword1: "",
      FLAG_CHANGE_PW: false,
      notifyCount: 0, // 通知
      list: [],
      // 平台首页
      platformHome: {
        name: this.$parent.$t("common_00015"),
        icon: "iconfont icon-zhuye1",
        iconS: "iconfont icon-zhuye",
        selectFLAG: false,
        router: "preview.html",
        permissionKey: "siteInfo",
        iconFLAG: true,
        active: 2000,
        focus: 2,
        nopermission: true,
        child: [],
      },
      // 场站地图***
      depotMap:{
        name: this.$parent.$t("common_00324"),
        icon: "iconfont icon-gailanbeifen",
        iconS: "iconfont icon-gailan",
        selectFLAG: false,
        router: "depotMap.html",
        permissionKey: "siteInfo",
        iconFLAG: true,
        active: 2003,
        focus: 15,
      },
      //场站中心
      site: {
        name: this.$parent.$t("common_00004"),
        icon: "iconfont icon-a-changzhanbeifen3",
        iconS: "iconfont icon-a-changzhanbeifen4",
        selectFLAG: false,
        router: "managementDepot.html",
        permissionKey: "siteInfo",
        iconFLAG: true,
        active: 1,
        nopermission: true,
        isClose: false,
        child: [
          {
            name: 'New Station',
            icon: "el-icon-document",
            children: [
              {
                name: 'New Station',
                router: "createDepot.html",
                permission: "siteInfo",
                focus: 9,
              },
            ],
          },
          {
            name: this.$parent.$t("common_00021"),
            icon: "el-icon-document",
            children: [
              {
                name: this.$parent.$t("common_00304"),
                router: "managementDepot.html",
                permission: "siteInfo",
                focus: 8,
              },
            ],
          },
          {
            name: 'Pricing Management',
            icon: "el-icon-document",
            children: [
              {
                name: 'Pricing Management',
                router: "rates.html",
                permission: "siteInfo",
                focus: 10,
              },
            ],
          },
          {
            name: this.$parent.$t("common_00028"),
            icon: "el-icon-document",
            children: [
              {
                name: this.$parent.$t("common_63013"),
                router: "addDevice.html",
                permission: "deviceMonitorList",
                focus: 2011,
              },
              {
                name: this.$parent.$t("common_00028"),
                router: "deviceMonitor.html#eq",
                permission: "deviceMonitorList",
                focus: 14,
              },
            ],
          },
        ],
      },
      //订单中心
      order: {
        name: this.$parent.$t("common_00005"),
        icon: "iconfont icon-a-dingdanbeifen4",
        iconS: "iconfont icon-a-dingdanbeifen5",
        selectFLAG: false,
        router: "bill.html",
        permissionKey: "chargeBillInfo",
        iconFLAG: true,
        active: 2,
        nopermission: true,
        isClose: false,
        child: [],
      },
      //维保中心
      maintenance: {
        name: this.$parent.$t("common_00006"),
        icon: "iconfont icon-bianzu",
        iconS: "iconfont icon-weibao",
        selectFLAG: false,
        router: "maintenanceHome.html",
        permissionKey: "DeviceErrorLogInfo",
        iconFLAG: true,
        active: 3,
        nopermission: true,
        isClose: false,
        child: [
          {
            name: this.$parent.$t("common_00052"),
            icon: "el-icon-document",
            children: [
              {
                name: this.$parent.$t("common_00053"),
                router: "chargeMonitor.html",
                permission: "deviceMonitorChart",
                focus: 36,
              },
              {
                name: this.$parent.$t("common_00054"),
                router: "bill.html#abnormal",
                permission: "chargeBillInfo",
                focus: 37,
              },
            ],
          },
          {
            name: this.$parent.$t("common_00056"),
            icon: "el-icon-document",
            children: [
              {
                name: this.$parent.$t("common_00057"),
                router: "errorLog.html",
                permission: "DeviceErrorLogInfo",
                focus: 39,
              },
              {
                name: this.$parent.$t("common_00059"),
                router: "platformLog.html",
                permission: "DeviceCommLogInfo",
                focus: 41,
              },
            ],
          },
          {
            name: this.$parent.$t("common_00060"),
            icon: "el-icon-document",
            children: [
              {
                name: this.$parent.$t("common_00061"),
                router: "deviceMonitor.html#maint",
                permission: "deviceMonitorList",
                focus: 42,
              },
              {
                name: this.$parent.$t("common_00062"),
                router: "powerMaint.html#power",
                permission: "DeviceLifeStatsInfo",
                focus: 43,
              },
              {
                name: this.$parent.$t("common_40000"),
                router: "powerMaint.html#eq",
                permission: "DeviceLifeStatsInfo",
                focus: 44,
              },
              // {
              //   name: this.$parent.$t("common_31007"),
              //   router: "autoNotice.html",
              //   permission: "deviceInfo",
              //   focus: 1005,
              // },
              {
                name: this.$parent.$t("common_31001"),
                router: "orderManagement.html",
                permission: "workFlowInfo",
                focus: 1001,
              },
              {
                name: this.$parent.$t("common_41001"),
                router: "orderTriggerList.html",
                permission: "workFlowInfo",
                focus: 1004,
              },
               {
                name: this.$parent.$t("common_31002"),
                router: "orderClassify.html",
                permission: "workFlowInfo",
                focus: 1003,
              },
              {
                name: this.$parent.$t("common_31003"),
                router: "orderAnalysis.html",
                permission: "workFlowInfo",
                focus: 1014,
              },
              {
                name: this.$parent.$t("common_31004"),
                router: "knowledge.html",
                permission: "workFlowInfo",
                focus: 1002,
              },
            ],
          },
        ],
      },
      //用户中心
      user: {
        name: this.$parent.$t("common_00008"),
        icon: "iconfont icon-a-bianzu15beifen5",
        iconS: "iconfont icon-yonghu",
        selectFLAG: false,
        router: "user.html",
        permissionKey: "wechatUserInfo",
        iconFLAG: true,
        active: 5,
        nopermission: true,
        isClose: false,
        child: [
          {
            name: this.$parent.$t("common_00072"),
            icon: "el-icon-document",
            children: [
              {
                name: this.$parent.$t("common_00075"),
                router: "group.html",
                permission: "userGroupInfo",
                focus: 56,
              },
            ],
          },
          {
            name: this.$parent.$t("common_00076"),
            icon: "el-icon-document",
            children: [
              {
                name: this.$parent.$t("common_00077"),
                router: "chargeCard.html",
                permission: "nfcgroupInfo",
                focus: 57,
              },
              {
                name: this.$parent.$t("common_00079"),
                router: "managementCharger.html#U3",
                permission: "nfcgroupInfo",
                focus: 59,
              },
            ],
          },
        ],
      },
      
      //数据中心
      record: {
        name: this.$parent.$t("common_00010"),
        icon: "iconfont icon-a-bianzu18beifen5",
        iconS: "iconfont icon-shuju",
        selectFLAG: false,
        router: "analyzeXcharge.html#whole",
        permissionKey: "biInfo",
        iconFLAG: true,
        active: 7,
        nopermission: true,
        isClose: false,
        child: [
          {
            name: this.$parent.$t("common_00111"),
            icon: "el-icon-document",
            children: [
              {
                name: this.$parent.$t("common_00112"),
                router: "analyzeXcharge.html#whole",
                permission: "biInfo",
                focus: 86,
              },
              {
                name: this.$parent.$t("common_00113"),
                router: "analyzeXcharge.html#site",
                permission: "biInfo",
                focus: 87,
              },
              {
                name: this.$parent.$t("common_00115"),
                router: "analyzeXcharge.html#date",
                permission: "biInfo",
                focus: 89,
              },
            ],
          },
          {
            name: this.$parent.$t("common_00118"),
            icon: "el-icon-document",
            children: [
              {
                name: this.$parent.$t("common_00119"),
                router: "analyzeCharge.html#whole",
                permission: "biInfo",
                focus: 92,
              },
              {
                name: this.$parent.$t("common_00120"),
                router: "analyzeCharge.html#site",
                permission: "biInfo",
                focus: 93,
              },
              {
                name: this.$parent.$t("common_00121"),
                router: "analyzeCharge.html#group",
                permission: "biInfo",
                focus: 94,
              },
            ],
          },
          {
            name: this.$parent.$t("common_00124"),
            icon: "el-icon-document",
            children: [
              {
                name: this.$parent.$t("common_00125"),
                router: "analyzeIncome.html#whole",
                permission: "biInfo",
                focus: 97,
              },
              {
                name: this.$parent.$t("common_00126"),
                router: "analyzeIncome.html#site",
                permission: "biInfo",
                focus: 98,
              },
              {
                name: this.$parent.$t("common_00127"),
                router: "analyzeIncome.html#group",
                permission: "biInfo",
                focus: 99,
              },
            ],
          },
          {
            name: this.$parent.$t("common_00132"),
            icon: "el-icon-document",
            children: [
              {
                name: this.$parent.$t("common_00133"),
                router: "analyzeUser.html#whole",
                permission: "biInfo",
                focus: 104,
              },
              {
                name: this.$parent.$t("common_00134"),
                router: "analyzeUser.html#site",
                permission: "biInfo",
                focus: 105,
              },
            ],
          },
          //屏蔽能源统计 12/28
          // {
          //   name: this.$parent.$t("common_20015"),
          //   icon: "el-icon-document",
          //   children: [
          //     {
          //       name: this.$parent.$t("common_20013"),
          //       router: "energyStatistics.html",
          //       permission: "energyStorageInfo",
          //       focus: 2002,
          //     }
          //   ],
          // }
        ],
      },
      //能源中心
      energy: {
        name: this.$parent.$t("common_20016"),
        icon: "iconfont icon-nengyuan",
        iconS: "iconfont icon-nengyuan",
        selectFLAG: false,
        router: "energyOperationMonitoring.html",
        permissionKey: "energyStorageInfo",
        iconFLAG: true,
        active: 11,
        nopermission: true,
        isClose: false,
        child: [
          {
            name: this.$parent.$t("common_00014"),
            icon: "el-icon-document",
            children: [
              {
                name: this.$parent.$t("common_60010"),
                router: "energyHome.html",
                permission: "energyStorageInfo",
                focus: 2005,
              },
              {
                name: this.$parent.$t("common_20010"),
                router: "energyOperationMonitoring.html",
                permission: "energyStorageInfo",
                focus: 2000,
              },
              {
                name: this.$parent.$t("common_20011"),
                router: "revenueMonitoring.html",
                permission: "energyStorageInfo",
                focus: 2001,
              },
              {
                name: this.$parent.$t("common_61073"),
                router: "workSchedule.html",
                permission: "energyStorageInfo",
                focus: 2006,
              },
            ],
          },
        ],
      },
      //系统中心
      system: {
        name: this.$parent.$t("common_00013"),
        icon: "iconfont icon-a-bianzu29beifen5",
        iconS: "iconfont icon-xitong",
        selectFLAG: false,
        router: "systemInfoSetting.html",
        permissionKey: "dealerInfo",
        iconFLAG: true,
        active: 10,
        nopermission: true,
        isClose: false,
        child: [
          {
            name: this.$parent.$t("common_00186"),
            icon: "el-icon-document",
            children: [
              {
                name: this.$parent.$t("common_00187"),
                router: "systemInfoSetting.html",
                permission: "dealerInfo",
                focus: 154,
              },
            ],
          },
          {
            name: this.$parent.$t("common_00188"),
            icon: "el-icon-document",
            children: [
              {
                name: this.$parent.$t("common_00182"),
                router: "accountManage.html",
                permission: "employeeInfo",
                focus: 156,
              },
            ],
          },
        ],
      },
      isCollapse: false,
      isFullScreen: false,
      sysName: "",
      userTitle: "",
      headImageUrl:"",
      adminImg:"",
      screenWidth: document.body.clientWidth,
      timer: false,
      widthMenu:'20px',
      flag: false,
      flagl : false
    };
  },
  props: ["isactive", "isfocus"],
  mounted() {
    this.initMenuSet();
    var notifyCountUrl = requestUrl + "/message/unread/count";
    // this.getNotifyCount(notifyCountUrl);
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  },
  watch: {
    screenWidth(newValue) {
      if (!this.timer) {
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          this.timer = false;
        }, 400);
      }
    },
    isShrink(val,old){
      if(!val){
        this.isCollapse = false;
      }
      if(val!=old){
        this.$nextTick(()=>{
          this.initMenuSet();
        })
      }
    }
  },
  computed: {
    isShrink() {
      let tag = this.screenWidth < 1370;
      if(tag){
        this.isCollapse = true
      }
      return tag;
    },
  },
  methods: {
    // 获取储能桩站点列表
    getSites() {
      ajax({
        type: "GET",
        url:
          requestUrl +
          "/site?brief=true&orderColumn=title&order=asc&energySite=true",
        dataType: "json",
        success: (response) => {
          const result = JSON.parse(response).result;
          if(!result||(result&&!result.length)) {
             for (let i = 0; i < this.list.length; i++) {
                if(this.list[i].active==11) {
                  this.$nextTick(()=>{
                    this.list.splice(i,1);
                  })
                }
              }
          }
        },
      });
    },
    // 跳转老版平台
    toV2(){
      this.$alert(this.$t('common_10009'), this.$t('common_00265'), {
          dangerouslyUseHTMLString:true,
          showCancelButton: true,
          confirmButtonText: this.$t('common_00234'),
          cancelButtonText: this.$t('common_00215'),
          lockScroll: false,
          callback: action => {
              if (action == 'confirm') {
                let url = 'http://service.xcharger.net/v2/';
                if(this.product!='cn'){
                  url = 'https://eu-service.xcharger.net/v2';
                }
                window.open(url);
              } else if (action == 'cancel') {
                  
              }
          }
      })
    },
    // 判断当前设备
    isPCFn(){
      let sUserAgent = window.navigator.userAgent.toLowerCase();
      let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";//判断是否为iPad
      let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";//判断是否为iPhone用户
      let bIsMidp = sUserAgent.match(/midp/i) == "midp";
      let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      let bIsAndroid = sUserAgent.match(/android/i) == "android";
      let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
  
      if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM)) {
          this.isPc = true; // 电脑打开
      }else{
          this.isPc = false; // 手机打开
      }
    },
    // 一级标题跳转页面
    tolink(val){
      let {router,permissionKey,active,child} = val
      if(!this.isPc) {
        // 移动端
        let refValue=false
        let menuKey='menu'+val.active
        if(this.$refs[menuKey]){
          refValue=this.$refs[menuKey][0].$el.className.indexOf('is-opened')!=-1;
        }
        active == this.catchActive&&refValue?val.isClose = !val.isClose:val.isClose=false;
        this.catchActive = active;
        if(!child||!child.length){
          let url = `./${router}`;
          let targetType = '_self';
          window.open(url,targetType);
        }
        return
      }
      // pc
      if(child && child.length) return;
      if(router=='#') return;
      if(this.noPermissions.includes(permissionKey)) return;
      let url = `./${router}`;
      let targetType = '_self';
      window.open(url,targetType);
    },
    // 未读信息数请求
    getRefundCount(url, callback) {
      var om = this;
      ajax({
        type: "GET",
        url: url,
        dataType: "json",
        success: function(response) {
          callback(JSON.parse(response));
        }
      });
    },
    changeSelect(){
      document.cookie = 'spvid='+this.sourceInfo
      window.location.href = './preview.html'
    },
    checkIdType(type) {
      return checkIdType(type);
    },
    //菜单隐藏
    initMenuSet(){
      var hideList = Array.prototype.slice.call(document.querySelectorAll('.el-menu-item-group ul'))
      hideList.forEach((e,index)=>{
        var childList = Array.prototype.slice.call(e.children);
        var temp = childList.filter((item) => {
            return item.style.cssText.search('display: none') < 0
        })
        if (temp.length === 0) {
          hideList[index].parentNode.parentNode.removeChild(hideList[index].parentNode);
        }
      })

      //隐藏模块
      var menuList = Array.prototype.slice.call(document.getElementsByClassName('el-submenu'))
      menuList.forEach((e,index) => {
        var childList = Array.prototype.slice.call(e.children)
        if(childList[1]){
          var itemMenu = null;
          if(!(this.isCollapse||this.isShrink)){
            itemMenu = Array.prototype.slice.call(childList[1].children)
          }else{
            itemMenu = Array.prototype.slice.call(childList[1].children[0].children)
          }
          if (itemMenu.length === 0) {
            menuList[index].style.display = "none"
          }
        }
      })
      // 展开当前菜单项
      let temp = this.list.find(it=>it.active==this.isactive&&it.child&&it.child.length);
      (!(this.isCollapse||this.isShrink)&&temp)&&this.$refs.elmenu.open(String(this.isactive));
    },
    //修改密码
    check() {
      if (!this.password) {
        this.$message.error(this.$t("common_00251"));
        return false;
      }
      if (!this.newPassword) {
        this.$message.error(this.$t("common_00252"));
        return false;
      }
      if (!this.newPassword1) {
        this.$message.error(this.$t("common_00253"));
        return false;
      }
      if (this.newPassword != this.newPassword1) {
        this.$message.error(this.$t("common_00254"));
        return false;
      }
      return true;
    },
    close() {
      this.FLAG_CHANGE_PW = false;
    },
    //修改密码
    uptPassword() {
      if (!this.check()) return;
      var param = {};
      param.loginId = this.loginId;
      param.password = this.password;
      param.newPassword = this.newPassword;
      var url = requestUrl + "/password";
      ajax({
        type: "POST",
        url: url,
        dataType: "json",
        async: false,
        data: JSON.stringify(param),
        success: (response) => {
          var info = JSON.parse(response);
          if (info.error) {
            this.$message.error(
              info.error.msg ? info.error.msg : info.error.code
            );
          } else {
            if (info.result) {
              this.$message({
                message: this.$t("common_00201"),
                type: "success",
              });
              this.FLAG_CHANGE_PW = false;
            }
          }
        },
      });
    },
    collapse() {
      if(this.isShrink) return;
      this.isCollapse = !this.isCollapse;
      this.$nextTick(()=>{
        this.initMenuSet();
      })
    },
    screenfull() {
      this.isFullScreen = !this.isFullScreen;
      screenfull.toggle();
    },
    //退出登录
    logout() {
      let object = new Object();
      object.loginId = this.loginId;
      ajax({
        type: "POST",
        url: `${requestUrl}/logout`,
        data: JSON.stringify(object),
        dataType: "json",
        success: (data) => {
          if (this.roleId == "1013636002184695808") {
            window.location.href = "http://www.elecbay.cn/xjyy";
          } else if (this.roleId == "1013637748365725696") {
            window.location.href = "http://www.elecbay.cn/service/";
          } else {
            window.location.href = "./login.html";
          }
        },
      });
    },
    // 跳转通知页面
    toNotify() {
      window.open("./notify.html");
    },
    // 未读通知条数
    getNotifyCount(url) {
      var om = this;
      ajax({
        type: "GET",
        url: url,
        dataType: "json",
        success: function (response) {
          var totalCount = JSON.parse(response).totalCount;
          om.notifyCount = totalCount;
        },
      });
    },
    toIndex(){
      window.location.href = "./preview.html";
    }
  },
  created() {
    this.isPCFn();
    this.lang = window.localStorage.lang;
    this.product = window.product_area;
    // 正确运营商注册时间字段
    // var dealerCreateTime = checkLogin("dealerCreateTime");
    // if(dealerCreateTime){
    //   20220228000000>Number(dealerCreateTime)?this.isOlduser = true:this.isOlduser = false;
    // }
    // 后端暂未上线正确字段--暂替字段
    var roles = checkLogin("roles");
    if(roles.createTime){
      20220228000000>Number(roles.createTime)?this.isOlduser = true:this.isOlduser = false;
    }
    var permissions = checkLogin("permissionsV2");
    let noPermissions = [];
    var permissionsArr = [];
    for(var i in permissions){
      permissionsArr.push(i)
      if(permissions[i][1]==0||permissions[i][1]==0){
        noPermissions.push(i)
      }
    }
    this.noPermissions = noPermissions;
    if(
      checkLogin("permissionsV2").siteInfo[0] === 2 &&
      checkLogin("permissionsV2").siteInfo[1] === 1
    ){
      this.creatFlag = true
    }
    if (permissionsArr) {
      this.getSites();
    }
    this.list.push(
      this.platformHome,
      this.site,
      this.depotMap,
      this.order,
      this.maintenance,
      this.user,
      this.record,
      this.energy,
      this.system,
    );
    let loginInfo = checkLogin("name");
    this.sysName = loginInfo.name;
    this.adminImg = checkLogin("imgUrl");
    let info = getLoginInfo();
    this.userTitle = info.username ? info.username : info.loginId;
    this.headImageUrl = info.headImageUrl;
    this.selectList = info.resources
    this.isSupervisor = info.isSupervisor
    this.loginId = info.loginId;
  },
};
</script>

<style scoped lang="scss">
@import "../assets/font/iconfont.css";

.container {
  background: #f7f7fa;
  .heade-bar {
    position: fixed;
    top: 0;
    z-index: 2000;
    width: 100%;
    display: flex;
    height: 60px;
    line-height: 60px;
    background: #fff;
    box-shadow: -10px 10px 20px 0px rgba(30, 30, 30, 0.05);
    border-bottom: 1px solid #ececec;
    .collapse-switcher {
      width: 40px;
      text-align: center;
      cursor: pointer;
      color: #9097ac;
      display: flex;
      align-items: center;
      .iconfont {
        font-size: 40px;
        margin-left: 10px;
        border-radius: 40px;
        width: 40px;
        height: 40px;
        line-height: 40px;
        &:hover {
          background: #eef2fd;
          transition: 0.4s;
        }
      }
    }
    .logo {
      flex: 1;
      height: 60px;
      line-height: 60px;
      margin-left: 10px;
      img {
        margin: 12px 10px 0;
        width: 36px;
        height: 36px;
        border-radius: 4px;
        cursor: pointer;
      }
      span {
        font-size: 18px;
        font-weight: 600;
        color: #212943;
        vertical-align: top;
        white-space: nowrap;
        cursor: pointer;
      }
    }
    .full-screen {
      display: flex;
      cursor: pointer;
      color: #8087a0;
      padding-right: 20px;
      align-items: center;
      .el-badge {
        height: 40px;
        line-height: 40px;
      }
      .iconfont {
        font-size: 40px;
        margin: 0 10px;
        border-radius: 40px;
        width: 40px;
        height: 40px;
        line-height: 40px;
        &:hover {
          background: #eef2fd;
          transition: 0.4s;
        }
      }
    }
    .tool-bar {
      .theme-picker {
        padding-right: 10px;
      }
      .lang-selector {
        padding-right: 10px;
        font-size: 15px;
        color: #fff;
        cursor: pointer;
      }
      .user-info-dropdown {
        font-size: 14px;
        padding-right: 20px;
        color: #2b3041;
        cursor: pointer;
        img {
          width: 35px;
          height: 35px;
          border-radius: 4px;
          margin: 12px;
          float: left;
          border-radius: 35px;
        }
      }
    }
  }
  .myMain {
    display: flex;
    margin-top: 60px;
    .menu-bar {
      .el-menu {
        position: fixed;
        background: #fff;
        box-shadow: 2px 0 4px 0 rgba(0, 0, 0, 0.1);
        height: calc(100vh - 61px);
        z-index:2000;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 0 !important;
        }
      }
      /deep/.menu_pt20{
        padding-top: 20px;
        box-sizing: border-box;
      }
    }
    .main-con {
      padding: 20px;
      flex: 1;
      //overflow-x: auto;
    }
  }
  .menu-bar-width {
    width: 235px;
    transition: width 0.4s;
    &.my_fade-enter-active, &.my_fade-leave-active {
        transition: all 0.4s ease;
    }
    &.my_fade-enter{
        width: 64px;
    }
    &.my_fade-enter-to{
        width: 226px;
    }
    &.my_fade-leave{
        width: 226px;
    }
    &.my_fade-leave-to{
        width: 64px;
    }
    .titleName {
      visibility: visible;
      display: inline-block;
    }
  }
  //todo1
  .menu-bar-collapse-width {
    width: 65px;
    transition: width 0.3s;
    &.my_fade-enter-active, &.my_fade-leave-active {
        transition: all 0.3s ease;
    }
    &.my_fade-enter{
        width: 226px;
    }
    &.my_fade-enter-to{
        width: 64px;
    }
    &.my_fade-leave{
        width: 64px;
    }
    &.my_fade-leave-to{
        width: 226px;
    }
    .titleName {
      visibility: hidden;
      display: inline-block;
    }
    .main-con {
      min-width: 900px;
    }
  }
  /deep/ .el-menu {
    border-right: none;
  }
  .titleName {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #8087A0;
  }
  /deep/ .el-submenu {
    margin-bottom: 1px;
  }
  /deep/ .el-submenu .el-submenu__title {
    // padding-left: 1px !important;
    height: 50px !important;
    line-height: 50px !important;
    padding: 0!important;
  }
  .m-title{
    padding-left: 20px;
    padding-right: 20px !important;
  }
  /deep/ .el-submenu__title i {
    padding-right: 10px;
    color: #8087a0;
    font-size: 20px;
  }
  .menu-bar-collapse-width {
    /deep/ .el-submenu__title {
      // padding-left: 2px !important;
      height: 50px !important;
      line-height: 50px !important;
    }
  }
}
.is-opened-no{
  background-color:initial;
  &:after{
      background-color:initial;
  }
  /deep/.el-submenu__title{
    &:hover, &:focus{
      background-color:initial !important;
    }
    .iconfont{
      color: #8087a0 !important;
    }
  }
}
/deep/.el-menu-item-group__title{
  display: none;
}
/deep/.el-menu-item{
  margin-bottom: 10px;
  &:hover, &:focus{
    background-color: initial;
  }
}
/deep/.el-menu-item-group{
  margin-bottom: 0;
}
/deep/.el-submenu__title{
  &:hover, &:focus{
    background-color:initial !important;
    .titleName,i {
      color: #0358BF !important;
      font-weight: 600;
    }
  }
}
/deep/.el-submenu > .el-submenu__title .el-submenu__icon-arrow{
  transform: rotate(-90deg);
  top: 40%
}
/deep/.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow{
  transform: none;
}
.dialog-changePw {
  color: #41526d;
  .model {
    margin-bottom: 10px;
    .title {
      margin-bottom: 6px;
    }
  }
  .buttons {
    text-align: right;
  }
}

.icon-a-changzhanbeifen4,
.icon-a-dingdanbeifen5,
.icon-weibao,
.icon-anquan,
.icon-yonghu,
.icon-yingxiao,
.icon-shuju,
.icon-caiwu1,
.icon-liuliang,
.icon-xitong {
  color: #5278e2 !important;
  transition: 0.3s;
}
/deep/.el-badge__content {
  min-width: 12px;
  box-sizing: content-box;
}
</style>
<style>
#menu{
  z-index: 2000;
}
a {
  background-color: transparent;
  text-decoration: none;
  color: #1c2237;
}
.query-btn {
  color: #5278e2 !important;
  border-color: #5278e2 !important;
  font-weight: 600 !important;
}
.heade-bar .el-badge__content.is-fixed {
  top: 10px !important;
  right: 30px !important;
}
.heade-bar .el-badge__content {
  height: 16px !important;
  line-height: 16px !important;
  padding: 0 2px !important;
}
.el-dialog__header {
  background: #eff2f6;
  font-weight: 600;
  padding: 0 0 0 20px !important;
  line-height: 60px;
}
.el-dialog__header span {
  color: #8087a0;
}
/* 1 */

/* todo */
.el-menu--vertical {
  top: 61px !important;
  left: 0px !important;
  border-left:3px solid #f5f5f8;
  height: calc(100% - 62px);
  scrollbar-width: none;
  -ms-overflow-style: none;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  overflow-y: scroll;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 1999!important;
  /* 规定 @keyframes 动画的名称。 */
  animation-name:noCollapseMenu;
  /* 规定动画完成一个周期所花费的秒或毫秒。默认是 0。 */
  animation-duration: 0.4s!important;
  /* 规定动画的速度曲线。默认是 "ease"。 */
  animation-timing-function: linear!important;
   /* 规定动画的延迟时间。默认是 0。 */
  animation-delay: 0!important;
  /* 规定动画被播放的次数。默认是 1。 */
  animation-iteration-count:1!important;
   /* 当动画完成后，保持最后一个属性值 */
  animation-fill-mode : forwards!important;
  /* animation: name duration timing-function delay iteration-count direction fill-mode; */
}
/* 以上可以简写为一个animation */
 /* animation:myfirst 4s linear 3s 3 alternate; */
.el-menu--vertical.collapse-menu{
  animation-name:collapseMenu!important;
}
.el-menu--vertical.collapse-menu-close{
  display: none;
}
@keyframes collapseMenu
{
from {
    -webkit-filter: blur(1px);
    -moz-filter: blur(1px);
    -o-filter: blur(1px);
    -ms-filter: blur(1px);
    filter: blur(1px);
    transform: translateX(-100%)
  }
to {
    filter: none;
    transform: translateX(65px);
  }
}
@keyframes noCollapseMenu
{
from {
    -webkit-filter: blur(1px);
    -moz-filter: blur(1px);
    -o-filter: blur(1px);
    -ms-filter: blur(1px);
    filter: blur(1px);
    transform: translateX(-100%)
  }
to {
    filter: none;
    transform: translateX(226px)
  }
}
.show{
  animation-name:collapseMenu!important;
  animation-duration: 0.4s;
  animation-timing-function: linear;
  animation-delay: 0;
  animation-iteration-count:1;
  animation-fill-mode : forwards

}
.show2{
  animation-name:noCollapseMenu!important;
  animation-duration: 0.4s;
  animation-timing-function: linear;
  animation-delay: 0;
  animation-iteration-count:1;
  animation-fill-mode : forwards

}
  /* opacity:1;
   transition: all 0.2s;
  transform: translateX(200px); */
.my_single:hover{
  color: #0358BF;
}
.is-openeds .el-submenu__title .titleName {
  color: #0358BF !important;
}
.is-openeds .el-submenu__title .iconfont {
  color: #0358BF !important;
  font-weight: 600;
}
/* 2 */

.el-menu--vertical::-webkit-scrollbar {
  display: none;
}
.el-menu--popup {
  max-height: 88vh;
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 200px;
  padding-top: 30px !important;
  background: transparent !important;
  box-shadow: none !important;
}
.el-menu--popup::-webkit-scrollbar {
  width: 0 !important;
}
.el-menu-item-group__title {
  padding: 7px 0 !important;
  margin-left: 22px;
  font-size: 14px !important;
  color: #5486ea !important;
}
.el-menu-item-group > ul {
  padding: 0;
  padding-left: 38px !important;
}
.el-menu--vertical .el-menu-item-group > ul{
  padding-left: 0 !important;
}
.el-menu-item-group {
  margin-bottom: 15px;
}
.my-el-menu-item {
  line-height: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  padding-left: 12px !important;
  margin-right: 12px !important;
  box-sizing: border-box;
}
.my-el-menu-item .disbled{
  pointer-events:none;
  color: #ccc;
  cursor: not-allowed;
}
.my-el-menu-item a {
  color: #303133;
  display: block;
  width: 100%;
}
.my-el-menu-item a:hover {
  color: #0358BF;
}
.my-el-menu-item {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
}
.my-el-menu-item a{
  color: #8087A0;
}
.menuActive a {
  color: #0358BF;
}
.menu_li .menu_li_span{
  padding: 0 6px;
  border-radius: 10px;
  background: #ed3512;
  color: #fff;
  vertical-align: top;
  font-size: 12px;
  margin-left: 4px;
}
</style>